export * from './SettingsLabel';
export { default } from './SettingsLabel';
